/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SSESafeboxWon = {
    /**
     * Attempt ID
     */
    id?: string;
    /**
     * Winner username
     */
    name?: string;
    /**
     * Winner avatar URL
     */
    avatar?: string;
    userId?: string;
    /**
     * Winning jackpot amount in cents
     */
    jackpot?: number;
    /**
     * Safebox round ID
     */
    roundId?: number;
    newRound?: {
        id?: number;
        /**
         * 4-digit code
         */
        code?: number | null;
        /**
         * New jackpot (30% of previous)
         */
        jackpot?: number;
        status?: SSESafeboxWon.status;
        attemptPrice?: number;
        winnerId?: string | null;
        createdAt?: string;
        updatedAt?: string;
    };
};
export namespace SSESafeboxWon {
    export enum status {
        '_0' = 0,
        '_1' = 1,
    }
}

